import { render, staticRenderFns } from "./TooltipMobileContent.vue?vue&type=template&id=1b70634c"
import script from "./TooltipMobileContent.vue?vue&type=script&lang=ts"
export * from "./TooltipMobileContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports